import type { DLocalCreateTokenError } from '#src/app/shared/types';

import type { DLocalSDK, Field } from './index';

type TokenResponse = {
	token?: string | undefined;
	error?: DLocalCreateTokenError;
};

export async function getDlocalToken(
	username: string | undefined,
	pan: Field | null,
	sdk: DLocalSDK | null,
): Promise<TokenResponse> {
	if (!sdk || !pan) {
		return {};
	}
	try {
		const { token } = await sdk.createToken(pan, {
			name: username,
		});
		return { token };
	} catch (error) {
		return { error: error as DLocalCreateTokenError };
	}
}
